import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Typography } from "components/atoms";
import { StudyPlannerScheduleDetailedCard } from "components/molecules";
import { StudyPlannerRescheduleDetailedCard } from "components/molecules/StudyPlannerRescheduleDetailedCard";
import { CalendarMobile } from "components/molecules/CalendarMobile";
import { useScreenSize } from "hooks";
import { MOBILE_WIDTH } from "utils/constants";
import "./index.scss";
import {
  useUpdateEventMutation,
  useValidateEventNewDateMutation,
} from "services/studyPlanner";
import dayjs from "dayjs";
import { ValidateMobileModal } from "../StudyPlannerPage/ValidateMobileModal";
import { BackButton } from "components/molecules";

interface IProps {
  theme: "light" | "dark";
}

export const RescheduleEvent = ({ theme }: IProps) => {
  const navigate = useNavigate();

  const screen = useScreenSize();

  const { state } = useLocation();

  const [selectedDay, setSelectedDay] = useState<any>();

  const [validateModal, setValidateModal] = useState({
    isShowModal: false,
    payload: {
      Status: "",
      Message: "",
    },
  });

  const handleValidateModalClose = () => {
    setValidateModal((prev) => ({ ...prev, isShowModal: false }));
  };

  const [
    validateEvent,
    { isLoading: isLoadingValidate, isError: isErrorValidate },
  ] = useValidateEventNewDateMutation();

  const [
    updateEvent,
    { isLoading: IsLoadingUpdateEvent, isError: IsErrorUpdateEvent },
  ] = useUpdateEventMutation();

  const handleUpdateEvent = async (eventId: any, newDate: any) => {
    try {
      await updateEvent({
        eventId: eventId,
        newDate: newDate,
      })
        .unwrap()
        .then(() => {
          handleValidateModalClose()
          navigate("/study-planner")
        });
    } catch (error) {
      console.log("error : ", error);
    }
  };

  const validateRescheduleDate = async (cardInfo: any, formatDate: any) => {
    try {
      await validateEvent({
        eventId: cardInfo.StudyPlannerEventId,
        newDate: formatDate,
      })
        .unwrap()
        .then((payload) => {
          if (payload.Status === "Success") {
            handleUpdateEvent(cardInfo.StudyPlannerEventId, formatDate);
          } else {
            setValidateModal((prev) => ({
              ...prev,
              isShowModal: true,
              payload: { Status: payload.Status, Message: payload.Message },
            }));
          }
        });
    } catch (error: any) {
      setValidateModal((prev: any) => ({
        ...prev,
        isShowModal: true,
        payload: { Status: error.status, Message: error.data.Message },
      }));
    }
  };

  useEffect(() => {
    if (screen.width > MOBILE_WIDTH) {
      navigate("/study-planner");
    }
  }, [screen, navigate]);

  return (
    <div className="schedule-event-mobile-wrapper">
      <BackButton theme={theme} fallbackPath="/study-planner" />
      <Typography variant="h6Bold" label="Reschedule" />
      <StudyPlannerRescheduleDetailedCard
        theme={theme}
        id={state.cardData.StudyPlannerEventId}
        editable={state.cardData.Editable}
      />
      <CalendarMobile setDay={setSelectedDay} />
      <div className="actions-btn-wrapper">
        <Button
          icon={false}
          type="online"
          label="Cancel"
          onClick={() => navigate(-1)}
        />
        <Button
          icon={false}
          type="score"
          label="Reschedule"
          isLoading={isLoadingValidate || IsLoadingUpdateEvent}
          onClick={() =>
            validateRescheduleDate(
              state.cardData,
              dayjs(selectedDay).format("YYYY-MM-DD")
            )
          }
        />
      </div>
      <ValidateMobileModal
        isOpen={validateModal.isShowModal}
        payload={validateModal.payload}
        handleOnclose={handleValidateModalClose}
        theme={theme}
        openBottom={true}
        performUpdate={handleUpdateEvent}
        newDay={selectedDay}
        cardInfo={state.cardData}
      />
    </div>
  );
};
